import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from '../ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    title: 'Ebook RESET 21 (PDF)',
    desc: 'El protocolo paso a paso con los 5 pilares de AEduclub.'
  }, {
    title: 'Plan de Acción de 21 Días',
    desc: 'Calendario diario de comidas y suplementación detallada.'
  }, {
    title: 'Recetario Sin Gluten',
    desc: '50 platos latinos anti-inflamatorios y fáciles de preparar en 15 minutos.'
  }, {
    title: 'Lista de Compras Inteligente',
    desc: 'Optimizado para supermercados en USA y Latinoamérica.'
  }, {
    title: 'Guía de Rituales Nocturnos',
    desc: 'Estrategias probadas para apagar los sofocos y recuperar el sueño profundo.'
  }, {
    title: 'Acceso a la Comunidad Skool',
    desc: 'Conexión con mujeres en tu misma etapa y llamadas de Zoom semanales.'
  }];
  return <section className="bg-cream py-24 px-6" data-id="element-195">
      <div className="max-w-5xl mx-auto" data-id="element-196">
        <FadeIn className="text-center mb-16" data-id="element-197">
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-4" data-id="element-198">
            Todo lo que incluye tu acceso
          </h2>
          <div className="w-24 h-1 bg-copper mx-auto" data-id="element-199"></div>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-200">
          {deliverables.map((item, idx) => <StaggerItem key={idx} className="bg-white p-6 shadow-sm border border-copper/10 flex gap-4 items-start" data-id="element-201">
              <CheckCircle2 className="w-6 h-6 text-copper flex-shrink-0 mt-1" data-id="element-202" />
              <div data-id="element-203">
                <h3 className="text-xl font-serif text-charcoal mb-2 font-bold" data-id="element-204">
                  {item.title}
                </h3>
                <p className="text-charcoal/70" data-id="element-205">{item.desc}</p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}